module.exports = __webpack_public_path__ + "media/stashboard/notification-image-37fc7099.png";